import styled, {
  createGlobalStyle,
  theme,
} from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React from 'react'

import CloseUi from '../close/Close'

const GlobalStyle = createGlobalStyle`
  body {
      height: auto;
      overflow-y: default;
      padding-right: 0;
    }
  ${(p) =>
    p.visible &&
    `
    body {
      height: 100vh;
      overflow-y: hidden;
      padding-right: 15px; /* Avoid width reflow */
    }
  `}
`

const Background = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 500;
  background: rgba(0, 0, 0, 0.25);
`

const Container = styled.div`
  background-color: ${theme('modal.background')};
  position: fixed;
  z-index: 1000;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  ${(p) =>
    p.fullscreen &&
    `
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    `}

  ${(p) =>
    !p.fullscreen &&
    `
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
      `}

  ${(p) =>
    !p.fullscreen &&
    p.theme.media.min.md`
      max-width: ${rem(960)};
      border-radius: ${rem(4)};
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    `}
`

const ScrollWrapper = styled.div`
  overflow-y: auto;
  max-height: 100vh;
  flex: 1;

  ${(p) =>
    !p.fullscreen &&
    `
      max-height: max(${rem(800)}, 100vh);
    `}

  ${(p) =>
    !p.fullscreen &&
    p.theme.media.min.md`
      border-radius: ${rem(4)};
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    `}
`

const Close = styled(CloseUi)`
  position: absolute;
  background-color: ${(p) => p.theme.overlayBada.icon.backgroud};
  color: ${(p) => p.theme.overlayBada.icon.color};
  top: ${(p) => p.theme.overlayBada.icon.top};
  right: ${rem(15)};
  ${(p) => p.theme.media.min.md`
    top: ${p.theme.overlayBada.icon.md.top};
    right: ${rem(25)};
  `}
`

export const Modal = React.forwardRef(
  ({ visible, onClose, fullscreen, children }, ref) => (
    <>
      {visible && (
        <>
          <GlobalStyle visible />
          <Background />
          <Container fullscreen={fullscreen} ref={ref}>
            <Close onClick={onClose} />
            <ScrollWrapper fullscreen={fullscreen}>{children}</ScrollWrapper>
          </Container>
        </>
      )}
    </>
  )
)

Modal.defaultProps = {
  fullscreen: false,
}

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fullscreen: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.array,
  ]).isRequired,
}
